import React from 'react';
import { CompassIcon, HeartIcon, SparklesIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { TornEdge } from './TornEdge';
import { Reveal } from './Reveal';
const files = [{
  folio: 'Exp. 001',
  icon: HeartIcon,
  label: 'Situaciones sentimentales',
  text: 'Consultas sobre relaciones, vínculos personales y situaciones afectivas.'
}, {
  folio: 'Exp. 002',
  icon: SparklesIcon,
  label: 'Limpieza y protección',
  text: 'Prácticas tradicionales de limpieza y protección espiritual.'
}, {
  folio: 'Exp. 003',
  icon: CompassIcon,
  label: 'Orientación personal',
  text: 'Lecturas de tarot y acompañamiento espiritual personalizado.'
}];
export function DifficultSituation() {
  return <section aria-labelledby="situacion-title" className="relative overflow-hidden bg-plum py-20 sm:py-28" data-id="element-17" data-mp="3m9at6ksiu41o">
      <TornEdge colorClassName="bg-plum" data-id="element-18" data-mp="11h8s3if11lq4" />
      <div aria-hidden="true" className="smoke-veil pointer-events-none absolute inset-0 opacity-45" data-id="element-19" data-mp="11gh711j236e3" />
      <div className="relative mx-auto w-full max-w-5xl px-5 sm:px-8" data-id="element-20" data-mp="opxmm7wemuvn">
        <Reveal data-id="element-21" data-mp="tl3bnfl3spny">
          <SectionHeading id="situacion-title" folio="Sección II · Acompañamiento" title="¿Estás atravesando una situación personal difícil?" data-id="element-22" data-mp="tor0w2jimpwv">
            <div className="mx-auto max-w-2xl space-y-5 text-center text-[0.98rem] leading-relaxed text-body sm:text-lg" data-id="element-23" data-mp="13irgwzgc5fkd">
              <p data-id="element-24" data-mp="aw6ff665bn33">
                Ofrecemos consultas y prácticas espirituales tradicionales
                relacionadas con situaciones sentimentales, personales y de
                orientación espiritual.
              </p>
              <p className="text-paper" data-id="element-25" data-mp="km81xtiuoxfw">
                Conoce nuestras opciones de consulta y descubre qué tipo de
                práctica puede estar relacionada con tu situación.
              </p>
            </div>
          </SectionHeading>
        </Reveal>

        <ul className="mt-14 grid gap-5 sm:grid-cols-3" data-id="element-26" data-mp="3o8qbm78dds51">
          {files.map(({
          folio,
          icon: Icon,
          label,
          text
        }, index) => <Reveal as="li" key={folio} stamp delay={index * 0.12} data-id="element-27" data-mp="3bbtw0yta775g" data-mpi={index}>
              <div className="relative h-full border border-gold/45 bg-plum-deep/70 p-7 pt-9 backdrop-blur-sm" data-id="element-28" data-mp="3b9fzsmmv7owb">
                <span className="absolute right-4 top-3 font-folio text-[0.6rem] uppercase tracking-[0.2em] text-gold/80" data-id="element-29" data-mp="3l1dew4gzv10b">
                  {folio}
                </span>
                <Icon className="h-6 w-6 text-emerald-soft" aria-hidden="true" data-id="element-30" data-mp="2xdlra4q071jq" />
                <h3 className="mt-5 font-display text-lg font-normal uppercase tracking-[0.1em] text-paper" data-id="element-31" data-mp="2sdzflzptptd1">
                  {label}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-body/90" data-id="element-32" data-mp="32a2rhxah96d6">
                  {text}
                </p>
              </div>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}